import { IInitialConfig } from '@app/app.module';

export const environment = {
    production: true,
    useMock: false,
};

export const initialConfig: () => IInitialConfig = () => window.ConfigInitial;
